import { Device } from '@/utils/device'
import type { BannerCarrosselProps } from '../../../banner-carrossel.props'
import './scss/count-down.scss'
import { useCountdown } from '@/utils/useCountdown'

interface CountDownProps {
    banner: BannerCarrosselProps
    device: number
    refresh?: boolean
}

export function CountDown({ banner, device, refresh = false }: Readonly<CountDownProps>) {
    const isMobile = device === Device.MOBILE || device === Device.APP

    const rawOpcoes = banner.opcoes
    const opcoes = typeof rawOpcoes === "string" ? JSON.parse(rawOpcoes) : rawOpcoes ?? {}

    const bgCorFundo: { style: { background: string } } | object = opcoes.corFundo ? { style: { background: '#'+ opcoes.corFundo} } : {}
    const borderColor: { style: { borderColor: string } } | object = opcoes.corFundo ? { style: { borderColor: '#'+opcoes.corFundo} } : {}

    const classTimerMobile = isMobile ? 'timer-mobile' : ''

    const modeloTimer = opcoes.modeloTimer || 'timer-1'
    const posicaoTimer = opcoes.posicaoTimer || 'timer-center'

    const styleContadorBanner: typeof bgCorFundo = (['timer-1', 'timer-2'].includes(modeloTimer)) ? {...bgCorFundo} : {}
    const styleCountDown: { style: { color: string } } | object = opcoes.corTexto ? { style: { color: '#'+opcoes.corTexto } } : {}

    const styleDia: typeof bgCorFundo = isMobile ? {...bgCorFundo} : {}
    const styleItemCount: typeof bgCorFundo = modeloTimer === 'timer-3' ? {...bgCorFundo} : {}

    const bgCorFundoMobile = isMobile ? {...bgCorFundo} : {}

    const tempoRestante = useCountdown(banner.data_fim ?? null, banner.data_inicio ?? null)

    return (
        <div className={`contador-banner flex align-center justify-center ${classTimerMobile} ${modeloTimer} ${posicaoTimer}`} {...styleContadorBanner}>
            <div className={`countdown tipo clearfix ${isMobile ? 'is-mobile' : ''}`}
                data-inicio={banner.data_inicio_formatada}
                data-fim={banner.data_fim_formatada}
                data-progress={modeloTimer === 'timer-2' ? '1' : '0'}
                data-diff-days='true'
                data-refresh={refresh}
                {...styleCountDown}
            >
                {modeloTimer == 'timer-2' && 
                    <div className="title flex">Promoção acaba em:</div>
                }

                <div className="alinha-contador flex align-center justify-center">
                    {banner.data_fim && (
                        <>
                            <span className="ctn dia" {...styleDia}>
                                <div className="item-count">
                                    <div className="count" {...styleItemCount}>{tempoRestante.dias}</div>

                                    {modeloTimer === 'timer-4' && (
                                        <span className="separator" {...borderColor}></span>
                                    )}

                                    {modeloTimer !== 'timer-2' && (
                                        <div className="tipo-tempo">dias</div>
                                    )}
                                </div>
                            </span>

                            {(modeloTimer === 'timer-1' || modeloTimer === 'timer-2') && (
                                <div className="text">:</div>
                            )}
                        </>
                    )}

                    <div className="ctn hora" {...bgCorFundoMobile}>
                        <div className="item-count">
                            <div className="count" {...(modeloTimer === 'timer-3' && Object.values(bgCorFundo).length) ? {...bgCorFundo} : {}}>
                                {tempoRestante.horas}
                            </div>

                            {(modeloTimer === 'timer-4') && (
                                <span className="separator" {...(Object.values(borderColor).length) ? {...borderColor} : {}}></span>
                            )}

                            {(modeloTimer !== 'timer-2') && (
                                <div className="tipo-tempo">horas</div>
                            )}
                        </div>
                    </div>

                    {(modeloTimer === 'timer-1' || modeloTimer === 'timer-2') && (
                        <div className="text">:</div>
                    )}

                    <div className="ctn min" {...(isMobile) ? {...borderColor} : {}}>
                        <div className="item-count">
                            <div className="count" {...(modeloTimer === 'timer-3') ? {...bgCorFundo} : {}}>
                                {tempoRestante.minutos}
                            </div>

                            {(modeloTimer === 'timer-4') && (
                                <span className="separator" {...borderColor}></span>
                            )}

                            {(modeloTimer !== 'timer-2') && (
                                <div className="tipo-tempo">
                                    {isMobile || modeloTimer === 'timer-3' ? 'min' : 'minutos'}
                                </div>
                            )}
                        </div>
                    </div>

                    {(modeloTimer === 'timer-1' || modeloTimer === 'timer-2') && (
                        <div className="text">:</div>
                    )}

                    <div className="ctn seg" {...(isMobile) ? {...bgCorFundo} : {}}>
                        <div className="item-count">
                            <div className="count" {...(modeloTimer === 'timer-3') ? {...bgCorFundo} : {}}>
                                {tempoRestante.segundos}
                            </div>

                            {(modeloTimer === 'timer-4') && (
                                <span className="separator" {...borderColor}></span>
                            )}
                            
                            {(modeloTimer !== 'timer-2') && (
                                <div className="tipo-tempo">
                                    { isMobile || modeloTimer === 'timer-3' ? 'seg' : 'segundos'}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {(modeloTimer === 'timer-2')
                    ? (
                        <div className="barra-progresso">
                            <div className="progresso" style={{ width: `${tempoRestante.progresso}%` }}></div>
                        </div>
                    )
                    : null}
            </div>
        </div>
    )
}